/**
 * Some lottie assets are authored to fade their artwork out in their final frames
 * (e.g. as a toast that auto-dismisses). When `loopAnimation` is false we want to
 * freeze on a fully-opaque "settled" pose instead, so this maps an animation file
 * to the last frame before its fade-out begins. Animations not listed here are
 * safe to freeze on their actual last frame.
 */
export const SAFE_END_FRAME: Partial<Record<string, number>> = {
    'success.json': 21,
};
